import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[appGlfocus]'
})
export class GlfocusDirective implements OnInit {
  @Input('appGlfocus') isFocused: boolean;

  constructor(private hostElement: ElementRef) {}

  public ngOnInit(): void {
    if (this.isFocused) {
      this.hostElement.nativeElement.focus();
    }
  }
}
